export default __webpack_public_path__ + "static/tour_01_recent_science_news-c6fd82aa04d491c7231f5e7d0368ba8a.jpg";